import { apiAxios } from "@helpers/lib/axios";
import { API_ENDPOINTS } from "@memorang/constants/urls";
import type { DashboardData, InsightsData } from "./schema";
import type { UserSessionStatus, UserSessionsByType } from "./user-sessions";

type PeriodType = "all_time" | "week" | "month";
type LeaderboardParams = {
	periodType: PeriodType;
	projectId: number;
	userPublicMetadataId: number;
	organizationId: number;
};
type Params = {
	itemId?: number;
	collectionId?: number;
	projectId: number;
	organizationId: number;
};

export const fetchLeaderboardItems = async ({
	periodType,
	projectId,
	organizationId,
	limit,
}: Omit<LeaderboardParams, "userPublicMetadataId"> & {
	limit: number;
}): Promise<
	{
		username: string;
		avatar: string;
		xp: number;
	}[]
> => {
	const { data } = await apiAxios.get(API_ENDPOINTS.LEADERBOARD, {
		params: { projectId, organizationId, periodType, limit },
	});

	return data.data.leaderboard;
};

export const fetchUserRank = async ({
	periodType,
	projectId,
	organizationId,
	userPublicMetadataId,
}: LeaderboardParams): Promise<{
	username: string;
	avatar: string;
	xp: number;
	level: number;
	rank: string;
}> => {
	const { data } = await apiAxios.get(
		API_ENDPOINTS.LEADERBOARD_RANK(userPublicMetadataId),
		{
			params: { projectId, organizationId, periodType },
		},
	);

	return data.data.leaderboardUserRecord;
};
export const fetchDashboardItems = async ({
	collectionId,
}: {
	collectionId: number;
}): Promise<DashboardData> => {
	const { data } = await apiAxios.post(API_ENDPOINTS.DASHBOARD_ITEMS, {
		collectionId,
		action: "LIBRARY",
		type: "QUESTION",
	});

	return data;
};

export const fetchInsights = async (params?: Params): Promise<InsightsData> => {
	const { itemId, collectionId, projectId, organizationId } = params ?? {};

	const { data } = await apiAxios.post(API_ENDPOINTS.USER_PROGRESS, {
		projectId,
		versionId: 1,
		itemId,
		organizationId,
		collectionId,
	});

	return data;
};

export const fetchUserSessions = async ({
	userId,
	collectionId,
	status,
}: {
	userId: number;
	collectionId: number;
	status?: UserSessionStatus;
}): Promise<UserSessionsByType> => {
	const { data } = await apiAxios.get(API_ENDPOINTS.USER_SESSIONS(userId), {
		params: {
			collectionId,
			...(status ? { status } : {}),
		},
	});

	return data.data;
};
